export default __webpack_public_path__ + "static/media/avichai-shtern.75f4e5ed.png";